import type { User } from '../api';
import { useDeviceClass } from '../../../shared/hooks/useDeviceClass';
import { LoginDesktopView } from '../views/LoginDesktopView';
import { LoginMobileView } from '../views/LoginMobileView';
import { LoginTabletView } from '../views/LoginTabletView';

export type LoginProps = { onLogin: (user: User) => void };

export function LoginPage(props: LoginProps) {
  const device = useDeviceClass();
  if (device === 'mobile') return <LoginMobileView {...props} />;
  if (device === 'tablet') return <LoginTabletView {...props} />;
  return <LoginDesktopView {...props} />;
}
